module.exports = __webpack_public_path__ + "img/TECNOLOGIA-VITARA-1.d96c0aa4.jpg";